export const PATIENT_LAUNCHED = 'SHA | Patient Launch';
export const PATIENT_CLOSED = 'SHA | Patient Close';
export const ORDER_SUBMITTED = 'SHA | Submit Order';
export const REFERRAL_SUBMITTED = 'SHA | Submit Referral';
export const PATIENT_EDUCATION_DOCUMENT_ACTION = 'SHA | Patient Education Document Action';
